// extracted by mini-css-extract-plugin
export default {"waiting_block":"WaitingBlock_waiting_block__dflfa","content":"WaitingBlock_content__eVkkX"};